import React from 'react'
import {useTranslation} from 'react-i18next'
import {Button, Dialog, DialogContent, makeStyles} from '@material-ui/core'
import {AppLoading} from 'AppLoading'
import edfImportType from './style'

interface ImportSuccessDialogProps {
  open: boolean
  onClose: () => void
  message: {
    manufacturer: string
    deviceName: string
    fileName: string
  } | null
  onConfirm: () => void
  loading: boolean
}

const useStyles = makeStyles(edfImportType)

const ImportSuccessDialog = (props: ImportSuccessDialogProps) => {
  const {open, onClose, message, onConfirm, loading} = props
  const {t} = useTranslation()
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      className={classes.container}
    >
      <AppLoading loading={loading} />
      <DialogContent>
        <div className={classes.contentContainer}>
          <div
            className={classes.listTitle}
            style={{
              textAlign: 'center',
              marginBottom: 40,
            }}
          >
            {t('IEDFRequestTitle')}
          </div>
          <div
            className={classes.listTitle}
            style={{
              marginBottom: 10,
            }}
          >
            IMPORT FILE
          </div>
          <ul
            className={classes.listCircleContainer}
            style={{
              marginBottom: 30,
            }}
          >
            <li>
              {t('IManufacturingCompany')}: {message?.manufacturer ?? ''}
            </li>
            <li>
              {t('IModelName')}: {message?.deviceName ?? ''}
            </li>
            <li>
              {t('IFileNameEdf')}: {message?.fileName ?? ''}
            </li>
          </ul>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-evenly',
            }}
          >
            <Button
              variant='contained'
              color='default'
              disableElevation
              onClick={onClose}
              disabled={loading}
              style={{
                width: 'fit-content',
                alignSelf: 'center',
              }}
            >
              {t('ICancel')}
            </Button>
            <Button
              variant='contained'
              color='primary'
              disableElevation
              onClick={onConfirm}
              disabled={loading}
              style={{
                width: 'fit-content',
                alignSelf: 'center',
              }}
            >
              {t('IOk')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ImportSuccessDialog
